import ReactQuill from "react-quill";
import constants from "../../../constants";
import BackSvgIcon from "../../../Svg/BackSvgIcon";
import { getDataFromStorage } from "../../../util";
import AlertContext from "../../../context/AlertContext";
import React, { useContext, useEffect, useState } from "react";
import ComplexityLabels from "../../CommonComponents/ComplexityLabels";
import CodingHeaderLearnerSideHooks from "../../../Hooks/CodingPage/CodingHeaderLearnerSideHooks";
import RichTextEditor from "../../CommonComponents/RichTextEditor";
import Banner from "../../Admin/QuestionEntry/CodingQuestionEntry/Banner";

export default function CodingProblem() {
  const Alert = useContext(AlertContext);
  const CodingHeaderLearnerSideHks = CodingHeaderLearnerSideHooks();

  const handleBack = () => {
    if (
      Alert.isFromProfile.current ||
      getDataFromStorage("role") === "customer"
    ) {
      Alert.navigate("/profiles/testpoints");
    } else {
      if (
        getDataFromStorage("role") === "learner" &&
        Alert.testData.testmode === constants.MODE.PRACTICE_MODE &&
        Alert.status !== constants.QUESTION_STATUS.SUBMITTED
      ) {
        CodingHeaderLearnerSideHks.saveCurrentAnswer();
      }

      Alert.setCodeDetails({});
      Alert.setFromCodeEditor(true);

      if (document.fullscreenElement) {
        document.exitFullscreen();
      }

      if (Alert.isAdmin) {
        localStorage.removeItem("splitPos");
        localStorage.removeItem("splitWidthPos");
        Alert.setLpId(Alert.lpId);

        if (Alert.showBreadCrumbsData?.from === "user") {
          Alert.setShowPopup(true);
          Alert.navigate(`batches/${sessionStorage.getItem("abatchid")}/users`);
        } else if (Alert.showBreadCrumbsData?.from === "old") {
          Alert.navigate(
            `batches/${sessionStorage.getItem("abatchid")}/report`,
          );
        } else if (Alert.showBreadCrumbsData?.from === "ccreportpage") {
          // Alert.setShowPopup(false);
          Alert.navigate(-1);
          Alert.setShowBreadCrumbsData({});
        } else if (Alert.showBreadCrumbsData.mockUse) {
          Alert.navigate(
            `batches/${sessionStorage.getItem(
              "abatchid",
            )}/dashboard?scope-ar=mock-test`,
          );
          Alert.setShowBreadCrumbsData({});
        } else {
          Alert.navigate(
            `batches/${sessionStorage.getItem(
              "abatchid",
            )}/path/${sessionStorage.getItem("aPathId")}/report#`,
          );
        }
      } else if (Alert.testData.mockuse) {
        Alert.navigate("/main/mock/results");
      } else if (Alert.testData.single) {
        console.log("Alert.testData.random", Alert.testData.random);
        if (Alert.testData.random) Alert.navigate(`/main/cc`);
        else Alert.navigate(`/main/cc/section/${Alert.testData.secid}`);
      } else if (Alert.showBreadCrumbsData?.from === "learner") {
        Alert.navigate("/main/dashboard/testresults");
      } else {
        Alert.setLpData({});
        localStorage.removeItem("splitPos");
        localStorage.removeItem("splitWidthPos");
        Alert.navigate("/home");
      }
    }
  };

  const [learnerTestCases, setLearnerTestCases] = useState([]);

  useEffect(() => {
    const testCases =
      Alert.codeDetails.testcases !== null
        ? JSON.parse(
            Alert.codeDetails.testcases !== null
              ? Alert.codeDetails.testcases
              : [],
          ).filter((testcase) => testcase.isexample === 1)
        : [];
    // console.log("testcases at admin side : ",testCases);
    // console.log("testcases at admin side without filter : ",Alert.codeDetails.testcases);
    setLearnerTestCases(testCases);
  }, [Alert.codeDetails]);

  const showVersionBanner =
    (Alert.isAdmin ||
      (!Alert.isAdmin &&
        (Alert.status === constants.QUESTION_STATUS.SUBMITTED ||
          Alert.status === constants.QUESTION_STATUS.TO_BE_EVALUATED))) &&
    Alert.codeDetails?.hasNewVersion &&
    Alert.codeDetails?.submittedVersion !== Alert.codeDetails?.latestVersion && Alert.codeDetails.isFixedQn;

  return (
    <div className="codingPageProblemMainContainer">
      <div className="codingPageProblemHeaderBackDiv">
        {(Alert.isAdmin ||
          (!Alert.isAdmin &&
            (Alert.status === constants.QUESTION_STATUS.SUBMITTED ||
              Alert.status === constants.QUESTION_STATUS.TO_BE_EVALUATED ||
              Alert.testData.testmode === constants.MODE.PRACTICE_MODE))) && (
          <BackSvgIcon component="codingProblem" onClick={handleBack} />
        )}
        {showVersionBanner ? (
          <Banner text="Note: New version is available for this question." />
        ) : null}
      </div>
      <div className="codingPageProblemHeader">
        <div className="codingPageProblemQuestionDiv">
          <div className="codingPageProblemQuestionName">
            {Alert.codeDetails?.name}
          </div>
          <ComplexityLabels complexityid={Alert.codeDetails?.complexityid} />
        </div>
        <RichTextEditor
          readOnly={true}
          value={Alert.codeDetails?.description}
          className="codingPageProblemReactQuill"
          init={{
            height: "100%",
            width: "100%",
            license_key: "gpl",
            readonly: true,
            menubar: false,
            branding: false,
            statusbar: false,
            elementpath: false,
            selector: "textarea",
            allow_html_in_named_anchor: true,
            plugins: [
              "link",
              "help",
              "code",
              "lists",
              "image",
              "table",
              "media",
              "anchor",
              "editor",
              "advlist",
              "preview",
              "charmap",
              "wordcount",
              "fullscreen",
              "autoresize",
              "visualblocks",
              "searchreplace",
              "insertdatetime",
            ],
            toolbar: "",
            content_style:
              "body { font-family:Inter,Arial,sans-serif; font-size:14px }",
          }}
        />
        {/* <ReactQuill
          readOnly={true}
          value={Alert.codeDetails?.description}
          className="codingPageProblemReactQuill"
        /> */}
      </div>
      <div className="codingPageProblemTestCasesDiv">
        {!Alert.codeDetails.istestcases && (
          <>
            <div className="codingPageProblemTestCasesDivHeader">
              Go through the following examples below to understand the problem
              better:
            </div>
            <div className="codingPageProblemTestCasesDivBody">
              <>
                {learnerTestCases.length !== 0 &&
                  learnerTestCases.map((testcase, index) => (
                    <div
                      key={index}
                      className="codingPageProblemTestCasesDivBodyContainer"
                    >
                      <div className="codingPageProblemTestCasesDivBodyContainerExampleDiv">
                        {" "}
                        Example {index + 1} :
                      </div>
                      <div className="codingPageProblemTestCasesDivBodyContainerInputDiv">
                        <div className="codingPageProblemTestCasesDivBodyContainerInputTitleDiv">
                          {testcase?.input !== "" &&
                            testcase?.input !== null &&
                            testcase?.input !== undefined &&
                            testcase.input.split("\n").map((input, ind) => {
                              if (!input.trim()) return;
                              return (
                                <div
                                  key={ind}
                                  className="codingPageProblemTestCasesDivBodyContainerInputTitle"
                                >
                                  <p className="codingPageProblemTestCasesDivBodyContainerInputVariable">
                                    {Alert.isInputVariable.current
                                      ? Alert.inputVariable[ind] + " : "
                                      : "Input" + (ind + 1) + " : "}
                                  </p>
                                  <p className="codingPageProblemTestCasesDivBodyContainerInputValue">
                                    {input}
                                  </p>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <div className="codingPageProblemTestCasesDivBodyContainerOutputVariable">
                        Output {index + 1} :
                      </div>
                      <div className="codingPageProblemTestCasesDivBodyContainerOutputValue">
                        {testcase?.output !== "" &&
                          testcase?.output !== null &&
                          testcase?.output !== undefined &&
                          testcase.output}
                      </div>
                    </div>
                  ))}
              </>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
